import templateUrl from "webforms/formio/formio-submission-prompt.htm";
import ServiceBus from "servicestack/service-bus";
import open from "webmodals/open";
import formioController from "webforms/formio/formio.controller";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import modals from "webmodals/modals";

export class FormSubmissionPromptContoller {
  constructor($scope, options) {
    const $ctrl = this;
    formioController($ctrl, $scope);
    console.debug("$constructor", { $ctrl, $scope, options });
    $ctrl.bus = new ServiceBus();
    Object.assign($ctrl, options);

    if ($ctrl.formio) {
      $ctrl.submission = {
        label: $ctrl.formio.id,
        data: {},
      };
      //console.debug("$getFormIO", { $ctrl, $scope, options });
      if (
        !$ctrl.formio.fields ||
        Object.keys($ctrl.formio.fields).length === 0
      ) {
        $ctrl.getFormIO($ctrl.formio.id).then((f) => {
          Object.assign($ctrl.formio, f);
          $ctrl.submission.label = f.id; //f.label;
        });
      }
    } else if ($ctrl.formioId) {
      $ctrl.submission = {
        label: $ctrl.formioId,
        data: {},
      };
      $ctrl.getFormIO($ctrl.formioId || $ctrl.formio.id).then((f) => {
        $ctrl.formio = f;
        $ctrl.submission.label = f.id; //f.label;
      });
    }

    $ctrl.prePopulateData();

    if ($ctrl.submissionId) {
      $ctrl.getFormSubmission($ctrl.submissionId).then((submission) => {
        $ctrl.submission = submission;
      });
    }
  }

  formChanged(e, submission) {
    const $ctrl = this;
    if (
      submission.data.zipcodeRepLookup &&
      submission.data.zipcodeRepLookup.length === 5
    ) {
      $ctrl.bus
        .send(
          "QuerySalesRepZipcode.json?Zipcode=" +
            submission.data.zipcodeRepLookup
        )
        .then(function (res) {
          if (res.data.total == 1) {
            $ctrl.submission.data.territoryRepId = res.data.results[0].id;
            $ctrl.submission.data.territoryRepName = res.data.results[0].name;
          }
        });
    }

    if (submission.data.MERGEVAR_zipCode && submission.data.MERGEVAR_zipCode.length === 5) {
      $ctrl.bus.send('QueryEmployees?ZipcodesContains=' + submission.data.MERGEVAR_zipCode).then(function(res) {
        $ctrl.MudPieTerritoryManager = res.data.results.filter(r => r.type == "Mud Pie Sales Division");
        $ctrl.GiftDivisionTerritoryManager = res.data.results.filter(r => r.type == "Gift Division");
        if ($ctrl.MudPieTerritoryManager.length) {
          submission.data.MudPieTerritoryManagerEmail = $ctrl.MudPieTerritoryManager[0].email;
        }
        if ($ctrl.GiftDivisionTerritoryManager.length) {
          submission.data.GiftDivisionTerritoryManagerEmail = $ctrl.GiftDivisionTerritoryManager[0].email;
        }
        var emails = [];
        if (submission.data.notify == "customerService") emails.push("webadmins@onecoast.com");
        if (submission.data.notify == "mudPieTerritoryManager") emails.push(submission.data.MudPieTerritoryManagerEmail);
        if (submission.data.notify == "giftDivisionTerritoryManager") emails.push(submission.data.GiftDivisionTerritoryManagerEmail);
        // if (submission.data.notify.customerService) emails.push("webadmins@onecoast.com");
        // if (submission.data.notify.mudPieTerritoryManager) emails.push(submission.data.MudPieTerritoryManagerEmail);
        // if (submission.data.notify.giftDivisionTerritoryManager) emails.push(submission.data.GiftDivisionTerritoryManagerEmail);
        submission.data.email = emails.join(";");
      });
    };

  }

  $onInit() {
    const $ctrl = this;
    //console.debug("$onInit", { $ctrl });
  }

  downloadForm() {
    const $ctrl = this;
    window.scrollTo(0,0);  
    html2canvas(document.querySelector("#formiodiv")).then((canvas) => {
      const doc = new jsPDF("p", "mm");
      var imgData = canvas.toDataURL("image/png");
      var imgWidth = 210;
      var pageHeight = 290;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      var position = 0;

      doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      doc.save($ctrl.formioId + ".pdf");
      $ctrl.bus.send("LogFormDownloaded.json", { Id: $ctrl.submissionId });
    });
    window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
  }

  formSubmission(e, submission) {
    const $ctrl = this;
    //console.debug("formSubmission", { $ctrl, e, submission });
    $ctrl.submission = submission;

    $ctrl.$close(submission);
    if ($ctrl.successMessage && $ctrl.successMessage != "") {
      modals.alert($ctrl.successMessage);
    }
    
  }
  prePopulateData() {
    const $ctrl = this;
    $ctrl.bus
      .send("QuerySalesRepList.json?Active=1&OrderBy=Name")
      .then(function (res) {
        if ($ctrl.formio != undefined && $ctrl.formio.fields) {
          var component = $ctrl.getComponentByKey(
            $ctrl.formio.fields,
            "salesRepLookup"
          );
          if (component && component.length) {
            component[0].values = [];
            res.data.results.forEach(function (obj) {
              component[0].data.values.push({ value: obj.id, label: obj.name });
            });
          }
        }
      });
    if ($ctrl.$session.isAuthenticated && $ctrl.$session.isRetailer()) {
      if ($ctrl.$session.retailerId && !$ctrl.retailer) {
        $ctrl.bus
          .send(`QueryRetailers.json?Id=${$ctrl.$session.retailerId}`)
          .then(function (res) {
            if (res.data.results) {
              $ctrl.retailer = res.data.results[0];
              var singleAddress = $ctrl.retailer.billingLocation.address + '\r\n';
              if ($ctrl.retailer.billingLocation.address2 != null && $ctrl.retailer.billingLocation.address2 != "") {
                singleAddress += $ctrl.retailer.billingLocation.address2 + '\r\n';
              }
              singleAddress += $ctrl.retailer.billingLocation.city + ', ' + $ctrl.retailer.billingLocation.state + ' ' + $ctrl.retailer.billingLocation.zip + '\r\n';
              singleAddress += $ctrl.retailer.billingLocation.country

              $ctrl.submission.data.companyName = $ctrl.retailer.companyName;
              $ctrl.submission.data.customerId = $ctrl.retailer.id;
              $ctrl.submission.data.retailerId = $ctrl.retailer.id;
              $ctrl.submission.data.billingAddressSingle =
                singleAddress;
              $ctrl.submission.data.billingAddress =
                $ctrl.retailer.billingLocation.address;
              $ctrl.submission.data.billingAddress2 =
                $ctrl.retailer.billingLocation.address2;
              $ctrl.submission.data.billingCity =
                $ctrl.retailer.billingLocation.city;
              $ctrl.submission.data.billingState =
                $ctrl.retailer.billingLocation.state;
              $ctrl.submission.data.billingZip =
                $ctrl.retailer.billingLocation.zip;
              $ctrl.submission.data.phone = $ctrl.submission.data.phone = $ctrl.retailer.phone.replace(/\D/g,'');;
              $ctrl.submission.data.email = $ctrl.retailer.email;
            }
          });
      }
      $ctrl.bus
        .send(
          `QueryRetailerShippingLocations.json?RetailerId=${$ctrl.$session.retailerId}`
        )
        .then(function (res) {
          if (res.data.results.length) {
            $ctrl.shippingLocation = res.data.results[0];

            var singleShipAddress = $ctrl.shippingLocation.address + '\r\n';
              if ($ctrl.shippingLocation.address2 != null && $ctrl.shippingLocation.address2 != "") {
                singleShipAddress += $ctrl.shippingLocation.address2 + '\r\n';
              }
              singleShipAddress += $ctrl.shippingLocation.city + ', ' + $ctrl.shippingLocation.state + ' ' + $ctrl.shippingLocation.zip + '\r\n';
              singleShipAddress += $ctrl.shippingLocation.country
              $ctrl.submission.data.shippingAddressSingle =
              singleShipAddress;
            $ctrl.submission.data.shippingAddress =
              $ctrl.shippingLocation.address;
            $ctrl.submission.data.shippingAddress2 =
              $ctrl.shippingLocation.address2;
            $ctrl.submission.data.shippingCity = $ctrl.shippingLocation.city;
            $ctrl.submission.data.shippingState = $ctrl.shippingLocation.state;
            $ctrl.submission.data.shippingZip = $ctrl.shippingLocation.zip;
          }
        });
      $ctrl.bus
        .send(
          `QueryRetailerContacts.json?RetailerId=${$ctrl.$session.retailerId}&IsPrimary=true`
        )
        .then(function (res) {
          if (res.data.results.length) {
            $ctrl.contact = res.data.results[0];
            $ctrl.submission.data.contact = $ctrl.contact.name;
            $ctrl.submission.data.email = $ctrl.contact.email;
          }
        });
    }
  }
}

export default ({
  size = "lg",
  backdrop = "static",
  placement = undefined, // "right",
  preventAutoHeight = true,
  submissionId,
  formioId,
  formio,
  okButtonText = submissionId ? "Add" : "Save",
  title = `Form Submission...`,
  subTitle,
  successMessage
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller: FormSubmissionPromptContoller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        submissionId,
        formio,
        formioId,
        title,
        subTitle,
        preventAutoHeight,
        okButtonText,
        successMessage
      }),
    },
  }).result;
